import { Checkbox, FormControlLabel, Box } from '@mui/material';

import Grid from '@mui/material/Grid2';
import { ConfirmModal } from 'shared/modals/confirmModal';

import intl from 'react-intl-universal';
import PropTypes from 'prop-types';

const propTypes = {
  showWarningBeforeSend: PropTypes.bool.isRequired,
  sendNewIssue: PropTypes.func.isRequired,
  handleShowWarningBeforeSendModalClose: PropTypes.func.isRequired,
  newIssueConfirmButtonIsLoading: PropTypes.bool.isRequired,
  darkMode: PropTypes.bool.isRequired,
  handleConfirmContentsCheckbox: PropTypes.func.isRequired,
  windowContents: PropTypes.object.isRequired,
};

const NewIssueModal = ({
  showWarningBeforeSend,
  sendNewIssue,
  handleShowWarningBeforeSendModalClose,
  newIssueConfirmButtonIsLoading,
  darkMode,
  handleConfirmContentsCheckbox,
  windowContents,
}) => {
  return (
    <ConfirmModal
      isOpened={showWarningBeforeSend}
      title={intl.get('new_modal_text_confirm_title')}
      bodyText={`*${intl.get('new_modal_text_confirm_text_correct')}`}
      bodyTextColor={'red'}
      onConfirm={sendNewIssue}
      onCancel={handleShowWarningBeforeSendModalClose}
      confirmButtonIsLoadingButton={true}
      confirmButtonIsLoading={newIssueConfirmButtonIsLoading}
      confirmButtonText={intl.get('new_modal_button_submit')}
      cancelButtonText={intl.get('new_modal_button_cancel')}>
      <Box sx={{ overFlowY: 'auto', maxWidth: 'xl' }}>
        {showWarningBeforeSend && windowContents}
        <Grid
          spacing={3}
          container
          justifyContent="flex-end"
          alignItems="flex-end"
          style={{ marginTop: '20px' }}>
          <Grid size={12}>
            <FormControlLabel
              data-testid="confirm-modal-checkbox"
              style={{ color: darkMode ? 'white' : 'black' }}
              control={
                <Checkbox
                  sx={{
                    color: '##66ccff', // Unchecked border and icon color
                    '&.Mui-checked': {
                      color: '#1976d2', // Checked color
                    },
                    '& .MuiSvgIcon-root': {
                      border: '2px solid #66ccff', // Custom border for the box
                      borderRadius: '4px', // Optional: rounded corners
                    },
                  }}
                  onChange={handleConfirmContentsCheckbox}
                />
              }
              label={intl.get('new_modal_text_confirm_text_sure')}
            />
          </Grid>
        </Grid>
      </Box>
    </ConfirmModal>
  );
};

NewIssueModal.propTypes = propTypes;
export default NewIssueModal;
